import styled from 'styled-components';
import { ProgressStepperStepLabelMixin } from '../../mixins/components/ProgressStepperStepLabelMixin';
export var StyledProgressStepperStepLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledProgressStepperStepLabel",
  componentId: "c11n-8-111-1__sc-y06vu6-0"
})(["", ""], ProgressStepperStepLabelMixin);